
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class vImageWithTooltip extends Vue {
  @Prop() imgSrc!: string;
  @Prop() imgStyle!: string;
  @Prop() tooltipContent!: string;
  @Prop() tooltipPlacement!: string;
}
